<template>
  <div id="container" v-if="fetch_data">
    <section id="event">
      <div class="wrap">
        <div class="register_step flex">
          <div class="step_box flex on">
            <div class="num">1</div>
            <p>申し込み<br class="sp">フォーム</p>
          </div>
          <div class="step_box flex on">
            <div class="num">2</div>
            <p>申し込み内容の<br class="sp">確認</p>
          </div>
          <div class="step_box flex">
            <div class="num">3</div>
            <p>決済情報の<br class="sp">入力</p>
          </div>
          <div class="step_box flex">
            <div class="num">4</div>
            <p>参加申し込みを<br class="sp">受け付けました</p>
          </div>
        </div>
        <div class="cts_box">
          <h2 class="sub_ttl"><span>申し込み内容の確認</span></h2>
          <p>
            以下の内容で研修会参加の申し込みを行います。
          </p>
        </div>

        <div class="cts_box">
          <h3 class="min_ttl">申し込み内容</h3>
          <div class="df_table">
            <dl class="flex">
              <dt>おなまえ</dt>
              <dd>{{ current_user.last_name }} {{ current_user.first_name }}</dd>
            </dl>
            <dl class="flex">
              <dt>塾生番号</dt>
              <dd>{{ current_user.number }}</dd>
            </dl>
          </div>
        </div>

        <div class="cts_box">
          <h3 class="min_ttl">お会計内容</h3>
          <p class="lead_txt">参加を希望されるすべての研修会の合計額を表示しています。</p>
          <div class="register_box">
            <dl class="flex">
              <dt>{{ model.title }}</dt>
              <dd class="item">{{ current_user.rank_label }}</dd>
              <dd class="price">¥{{ delimited(total_price) }}</dd>
            </dl>

            <dl class="flex" v-if="use_points">
              <dt>ポイントのご利用</dt>
              <dd class="item"></dd>
              <dd class="price">-{{ delimited(use_points) }}</dd>
            </dl>
            <dl class="flex total">
              <dt></dt>
              <dd class="item">お会計合計：</dd>
              <dd class="price">¥{{ delimited(total_price) }}</dd>
            </dl>
          </div>
        </div>

        <div class="cts_box" v-if="total_price > 0">
          <div class="button_wrap">
            <p class="alnC mb20">
              内容に変更なければ<br class="sp">続いて代金の決済を行います
            </p>
            <button type="button" class="submit light arrow" @click="paymentClicked()">決済情報を入力する</button>
            <div class="paygent flex">
              <img src="/common/images/paygent_logo.png" alt="PAYGENT">
              <p>
                クレジットカード決済サービス会社（PAYGENT）の決済画面に移動します。PAYGENTは、NTTデータと三菱UFJニコスの合弁による国内大手決済サービス会社です。
              </p>
            </div>
          </div>
        </div>

        <div class="cts_box" v-else>
          <div class="button_wrap">
            <p class="alnC mb20">
              内容に変更なければ<br class="sp">以下のボタンを押してください。（決済は不要です）
            </p>
            <button type="button" class="submit light arrow" @click="paymentClicked()">講義動画を購入する</button>
          </div>
        </div>

        <div class="cts_box">
          <div class="button_wrap">
            <p class="alnC mb20">
              入力内容を変更する場合は<br class="sp">こちらのボタンを押してください
            </p>
            <router-link :to="{ name: 'SnsPostSale', params: {id: model.id}, query: $route.query}"
                         class="submit light skeleton arrow back">
              前のページにもどる
            </router-link>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  components: {},
  data() {
    return {
      id: this.$route.params.id,
      fetch_data: null,
      request_exec: false,
      model: null,
      use_points: null,
      total_price: null
    }
  },
  mounted() {
    // form token
    if (!this.checkFormToken('SnsPostSale')) {
      this.$router.push({name: 'SnsPostSale', params: {id: this.$route.params.id}})
    }

    if (!this.$store.state.sns_post_sale) {
      this.$router.push({name: 'SnsPostSale', params: {id: this.$route.params.id}})
    } else {
      this.use_points = this.$store.state.sns_post_sale.use_points
      this.total_price = this.$store.state.sns_post_sale.total_price
    }
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}sns/sns_post_sale.json`, {
            params: {
              id: this.$route.params.id,
            }
          })
          .then(response => {
            this.fetch_data = response.data
            this.model = response.data
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },

    paymentClicked() {
      if (this.request_exec) return
      this.request_exec = true

      this.startUpload()
      this.axios
          .post(`${this.env.api_base_url}users/sns_post_sale/paygent.json`, {
            sns_post_sale_id: this.id,
            use_points: this.use_points
          })
          .then((response) => {
            // console.log(response)
            document.location.href = response.data.url
          })
          .catch((error) => {
            if (error.response.data.error) {
              alert(error.response.data.error)
            } else {
              this.errorAjax(error)
            }
          })
          .finally(() => {
            this.finishUpload()
            this.request_exec = false
          })
    },
  }
}
</script>
